import "./style.scss";
import React, { useState, useEffect } from "react";
import { Col, Row, Nav, NavItem, NavLink } from "reactstrap";
import "assets/scss/website/app.scss";
import classnames from "classnames";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import "nouislider/distribute/nouislider.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters } from "store/filter/actions";
import { toast } from "react-toastify";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import { useTranslation } from "react-i18next";
import UnitTypesService from "services/Admin/UnitTypesService";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import AreasService from "services/Admin/AreasService";
import CategoriesService from "services/Admin/CategoriesService";
import CountriesService from "services/Admin/CountriesService";

const ResaleHeader = ({ history }) => {
	const AuthData = useSelector((state) => state.Auth);
	const lang = useSelector((state) => state?.Auth?.lang);
	const { t } = useTranslation();
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [dropdownOpenSize, setDropdownOpenSize] = useState(false);
	const [show, setShow] = useState(false);
	const filterData = useSelector((state) => state.filter);
	const [locationOptions, setLocationOptions] = useState([]);
	const [unitTypeOptions, setUnitTypeOptions] = useState([]);
	const [finishingOptions, setFinishingOptions] = useState([]);
	const [categortiesOptions, setCategortiesOptions] = useState([]);
	const [countriesOptions, setCountriesOptions] = useState([]);
	const [resaleOptions, setResaleOptions] = useState([]);
	const dispatch = useDispatch();

	const toggle = () => setDropdownOpen((prevState) => !prevState);
	const toggleSize = () => setDropdownOpenSize((prevState) => !prevState);

	const handleSubmit = (e, v) => {
		if (filterData.activeTab === "1") {
			if (!filterData.country) {
				toast.error(t("Country Field required"));
				return;
			} else if (!filterData.location) {
				toast.error(t("Location Field required"));
				return;
			} else if (filterData?.unitType.length === 0) {
				toast.error(t("Property Type Field required"));
				return;
			}
			history.push("/advanced-filter");
		} else {
			if (filterData.ResaleLocation === "") {
				toast.error(t("Location Field required"));
				return;
			} else if (filterData?.unitType.length === 0) {
				toast.error(t("Property Type Field required"));
				return;
			}
			history.push("/resale");
		}
	};
	const payment_methods = [
		{
			label: t("Cash"),
			value: "Cash",
		},
		{
			label: t("installment"),
			value: "Installment",
		},
	];
	const resalePayment_methods = [
		{
			label: t("Cash"),
			value: "Cash",
		},
		{
			label: t("Installment"),
			value: "Installment",
		},
		{
			label: t("Installment with Owner"),
			value: "Owner Installment",
		},
	];
	const onSlide = (...rest) => {
		dispatch(
			appendFilters({ budget: [parseInt(rest[2][0]), parseInt(rest[2][1])] })
		);
	};

	const onSlideSize = (...rest) => {
		dispatch(
			appendFilters({ size: [parseInt(rest[2][0]), parseInt(rest[2][1])] })
		);
	};

	const homeService = new HomeService();
	const areaService = new AreasService();
	const unitTypesService = new UnitTypesService();
	const finishingTypesService = new FinishingTypesService();
	const categoriesService = new CategoriesService();
	const countriesService = new CountriesService();

	useEffect(() => {
		const params = {};
		params["type"] = filterData.activeTab === "2" ? "resale" : "unit";
		homeService.getRangeFilter(params).then((response) => {
			if (response && response.status === SuccessOk) {
				dispatch(
					appendFilters({
						budgetRange:
							response.data.minPrice == response.data.maxPrice
								? [1, response.data.maxPrice]
								: [response.data.minPrice, response.data.maxPrice],
						sizeRange:
							response.data.minSize == response.data.maxSize
								? [1, response.data.maxSize]
								: [response.data.minSize, response.data.maxSize],
						budget: [response.data.minPrice, response.data.maxPrice],
						size: [response.data.minSize, response.data.maxSize],
						getRanges: true,
					})
				);
			}
		});
	}, [filterData.activeTab]);

	useEffect(() => {
		const isExist = filterData.paymentMethods.includes("Owner Installment");
		if (filterData.activeTab === "1" && isExist) {
			dispatch(appendFilters({ paymentMethods: [] }));
		}
	}, [filterData.activeTab]);

	const getSelectData = (service, setData, type) => {
		service.getDropDown().then((res) => {
			const data = res.data.map((item) => {
				return {
					name: item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setData(data);

			if (type === "unitTypeOptions") {
				dispatch(appendFilters({ unitTypeOptions: data }));
			}
			if (type === "finishingOptions") {
				dispatch(appendFilters({ finishingOptions: data }));
			}
			if (type === "categortiesOptions") {
				dispatch(appendFilters({ CategortiesOptions: data }));
			}
		});
	};

	useEffect(() => {
		getSelectData(unitTypesService, setUnitTypeOptions, "unitTypeOptions");
		getSelectData(
			finishingTypesService,
			setFinishingOptions,
			"finishingOptions"
		);
		getSelectData(
			categoriesService,
			setCategortiesOptions,
			"categortiesOptions"
		);

		countriesService.getDropDown().then((res) => {
			const data = res?.data?.map((item) => {
				return {
					name: item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setCountriesOptions(data);
			dispatch(appendFilters({ countriesOptions: data }));
		});
	}, []);

	useEffect(() => {
		if (!!filterData.country?.value) {
			areaService.getAreasDropDown(filterData.country.value).then((res) => {
				const data = res.data?.map((item) => {
					return {
						name: item.name,
						label: item.name[`${AuthData.lang}`]
							? item.name[`${AuthData.lang}`]
							: item.name.en,
						value: item.id,
					};
				});
				setLocationOptions(data);
				dispatch(appendFilters({ locationOptions: data }));
			});
		}
	}, [filterData.country]);

	useEffect(() => {
		if (filterData.activeTab !== "1") {
			areaService.getAreaDropDown().then((res) => {
				const data = res.data?.map((item) => {
					return {
						name: item.name,
						label: item.name[`${AuthData.lang}`]
							? item.name[`${AuthData.lang}`]
							: item.name.en,
						value: item.id,
					};
				});
				setLocationOptions(data);
				dispatch(appendFilters({ locationOptions: data }));
			});
		}
	}, [filterData.activeTab]);

	const m = (num) => {
		if (!num) {
			return 0;
		}
		num = num.toString().replace(/[^0-9.]/g, "");
		if (num < 1000) {
			return num;
		}
		let si = [
			{ v: 1e3, s: `${t("K")}` },
			{ v: 1e6, s: `${t("M")}` },
			{ v: 1e9, s: "B" },
			{ v: 1e12, s: "T" },
			{ v: 1e15, s: "P" },
			{ v: 1e18, s: "E" },
		];
		let index;
		for (index = si.length - 1; index > 0; index--) {
			if (num >= si[index].v) {
				break;
			}
		}
		return (
			(num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") +
			si[index].s
		);
	};

	useEffect(() => {
		if (filterData.resale?.length <= 1) {
			return;
		}

		homeService.getResaleData(filterData.resale).then((res) => {
			if (res?.status === SuccessOk) {
				let response = res?.data?.map((info) => {
					return {
						label: info.name[lang],
						value: info.name[lang],
					};
				});
				setResaleOptions(response);
				setShow(true);
			}
		});
	}, [filterData?.resale]);

	const promiseOptions = (inputValue) => {
		if (inputValue?.length <= 1) {
			document.getElementById("searchCompound")?.classList.add("specialDiv");
			return;
		}

		return new Promise((resolve, reject) => {
			homeService
				.getDeveloperCompoundData(inputValue)
				.then((res) => {
					if (res?.status) {
						const compounds = res?.data?.compounds?.map((comp) => {
							return {
								...comp,
								type: "compound",
								label: comp?.name?.en, // Set label to the English name
								value: comp?.id, // Set value to the compound ID
							};
						});
						const developers = res?.data?.developers?.map((developer) => {
							return {
								...developer,
								type: "developer",
								label: developer?.name?.en, // Set label to the English name
								value: developer?.id, // Set value to the compound ID
							};
						});
						document
							.getElementById("searchCompound")
							?.classList.remove("specialDiv");
						// setOptions([...compounds, ...developers]); // Assuming you're using state to hold the options
						// resolve([...compounds, ...developers]);
						resolve([
							{
								label: "compounds",
								options: compounds,
							},
							{
								label: "developers",
								options: developers,
							},
						]);
					} else {
						reject(new Error("Failed to fetch compounds"));
					}
				})
				.catch((error) => {
					reject(error); // Handle error appropriately
				});
		});
	};

	const promiseResaleOptions = (inputValue) => {
		if (inputValue?.length <= 1) {
			document.getElementById("searchResale")?.classList.add("specialDiv");
			return;
		}

		return new Promise((resolve, reject) => {
			homeService
				.getResaleData(inputValue)
				.then((res) => {
					if (res?.status) {
						const resl = res?.data?.map((resaleRes) => {
							return {
								...resaleRes,
								type: "resale",
								label: resaleRes?.name?.en, // Set label to the English name
								value: resaleRes?.name?.en, // Set value to the compound ID
							};
						});
						document
							.getElementById("searchResale")
							?.classList.remove("specialDiv");
						resolve([
							{
								options: resl,
							},
						]);
					} else {
						reject(new Error("Failed to fetch resales"));
					}
				})
				.catch((error) => {
					reject(error); // Handle error appropriately
				});
		});
	};

	return (
		<div className="container header-resale">
			<div className="row">
				<div className="col-lg-6 m-auto">
					<div className="row filter-title">
						<div className="col-12">
							<div className="custom-title">
								<p className="main-title">{t("SELL YOUR")}</p>
								<p className="italic-title">
									{t("owned property ")}
									<span className="second-title">{t("IN")}</span>
								</p>
								<div className="d-lg-flex mt-3">
									<p className="description-title">
										Sell Your Property with Meras by easy steps you will add
										your property to sell
									</p>
									<p className="second-title">ONE CLICK</p>
								</div>
							</div>
						</div>
						<div className="col-12">
							<div className="filterHome">
								<AvForm>
									<div className="tabsHome">
										<div className="d-flex justify-content-center">
											<Nav tabs className="p-0 gap-2 tabsFilter">
												<NavItem
													className={AuthData.lang !== "ar" ? "left" : "right"}>
													<NavLink
														className={classnames("font-size-14 fw-bold", {
															active: filterData.activeTab === "1",
														})}
														onClick={() =>
															dispatch(
																appendFilters({
																	activeTab: "1",
																	resale: "",
																	compound: "",
																})
															)
														}>
														{t("buy")}
													</NavLink>
												</NavItem>
												<NavItem
													className={AuthData.lang !== "ar" ? "right" : "left"}>
													<NavLink
														className={classnames("font-size-14 fw-bold", {
															active: filterData.activeTab === "2",
														})}
														onClick={() =>
															dispatch(
																appendFilters({
																	activeTab: "2",
																	compound: "",
																	resale: "",
																})
															)
														}>
														{t("resale")}
													</NavLink>
												</NavItem>
											</Nav>
										</div>
										<div
											style={{
												background: "#fde0ce",
												padding: "2rem 1.5rem",
											}}
											className={classnames(
												"rounded-4",
												{ "search-Container-ar": AuthData.lang === "ar" },
												{ "search-Container-en": AuthData.lang !== "ar" }
											)}>
											<Row className="w-100 m-auto">
												{filterData.activeTab === "1" ? (
													<Col
														lg={3}
														md={12}
														className="input-search custom-search">
														<AsyncSelect
															placeholder={t(
																"compound and developer search placeholder"
															)}
															// cacheOptions
															defaultOptions
															className="font-size-14"
															id="searchCompound"
															value={filterData.compound}
															loadOptions={promiseOptions}
															onChange={(e) => {
																dispatch(appendFilters({ compound: e }));
															}}
														/>
													</Col>
												) : (
													<Col
														lg={3}
														md={12}
														className="input-search custom-search">
														<AsyncSelect
															placeholder={t("resale search placeholder")}
															// cacheOptions
															defaultOptions
															id="searchResale"
															// className='form-control btnHeight mb-2'
															value={filterData.resale}
															loadOptions={promiseResaleOptions}
															onChange={(e) =>
																dispatch(appendFilters({ resale: e }))
															}
														/>
														{/* {(!!resaleOptions?.length && filterData.resale?.length >=2 && show) && <div className="resale-options">
                              <ul>
                                {resaleOptions?.map((resale, index)=>{
                                  return <li 
                                    key={index}
                                    onClick={()=> {
                                      dispatch(appendFilters({ resale: resale?.label }))
                                      setShow(false)
                                    }}
                                  >{resale?.label}</li>
                                })}
                              </ul>
                            </div>} */}
													</Col>
												)}
												<Col
													lg={filterData.activeTab === "1" ? 4 : 4}
													className="px-lg-0">
													<div className="d-md-flex h-100 d-block gap-2">
														{filterData.activeTab === "1" && (
															<div className="w-100 custom-search2">
																<Select
																	placeholder={t("Country")}
																	options={countriesOptions}
																	onChange={(data) =>
																		dispatch(appendFilters({ country: data }))
																	}
																	value={filterData.country}
																	style={{
																		height: "50px",
																		borderRadius: "25px",
																	}}
																/>
															</div>
														)}

														<div className="w-100">
															{filterData.activeTab === "1" ? (
																<div className="custom-search2">
																	<Select
																		placeholder={t("Location")}
																		options={
																			!filterData.country ? [] : locationOptions
																		}
																		noOptionsMessage={() => {
																			if (!filterData.country) {
																				return "Choose Country First";
																			} else if (locationOptions?.length == 0) {
																				return "No Choose";
																			}
																		}}
																		onChange={(data) =>
																			dispatch(
																				appendFilters({ location: data })
																			)
																		}
																		value={filterData.location}
																	/>
																</div>
															) : (
																<div>
																	<div className="w-100 custom-search2">
																		<Select
																			placeholder={t("Location")}
																			options={locationOptions}
																			onChange={(data) =>
																				dispatch(
																					appendFilters({
																						ResaleLocation: data,
																					})
																				)
																			}
																			value={filterData.ResaleLocation}
																		/>
																	</div>
																</div>
															)}
														</div>
														{filterData.activeTab === "2" && (
															<div className="w-100 custom-search2">
																<Select
																	placeholder={t("property")}
																	// options={  [{ label: t("select label"), value: "Select" }, ...filterData.unitTypeOptions]}
																	options={unitTypeOptions}
																	onChange={(data) => {
																		dispatch(
																			appendFilters({ unitType: [data] })
																		);
																	}}
																	value={
																		filterData?.unitType?.length
																			? filterData?.unitType[0]
																			: null
																	}
																/>
															</div>
														)}
														{/* <div className=' progressbar w-100 ps-2 pe-2'>
                              <label>{t("budget")}</label>
                              <Dropdown className="mt-2" color="light" isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle data-toggle="dropdown"
                                  tag="span">
                                  <div className="d-flex text-dark justify-content-between  align-items-md-center">
                                    <span style={{ fontSize: "16px", marginTop: "2px",paddingBottom: "0.5rem" }}> 
                                      {m(filterData.budget[0]) === "1000K" ?`1${t("M")}` : m(filterData.budget[0])} - {m(filterData.budget[1])}
                                    </span>
                                    <span style={{ marginTop: "2px" }}>
                                      <i className="fas fa-chevron-down text-primary"></i>
                                    </span>
                                  </div>
                                </DropdownToggle>
                                <DropdownMenu className="p-4">
                                  <Nouislider
                                    range={{ min: filterData.budgetRange[0], max: filterData.budgetRange[1] }}
                                    tooltips={false}
                                    start={filterData.budget}
                                    connect
                                    step={5000}
                                    onSlide={onSlide}
                                    direction={AuthData.lang !== "ar" ? "ltr" : "rtl"}
                                  />
                                </DropdownMenu>
                              </Dropdown>
                            </div> */}
														{/* <div className='progressbar w-100 ps-2 pe-2'>
                              <label>{t("Built Up Area")} ({t("sqm")})</label>
                              <Dropdown className=" mt-2" color="light" isOpen={dropdownOpenSize} toggle={toggleSize}>
                                <DropdownToggle data-toggle="dropdown"
                                  tag="span">
                                  <div className="d-flex text-dark justify-content-between  align-items-md-center">
                                    <span style={{ fontSize: "16px", marginTop: "2px" }}> 
                                      {parseInt(filterData.size[0])} - {parseInt(filterData.size[1])}</span>
                                    <span style={{ marginTop: "2px" }}>
                                      <i className="fas fa-chevron-down text-primary"></i>
                                    </span>
                                  </div>
                                </DropdownToggle>
                                <DropdownMenu className="p-4">
                                  <Nouislider
                                    range={{ min: filterData.sizeRange[0], max: filterData.sizeRange[1] > 0 ? filterData.sizeRange[1] : 1}}
                                    tooltips={false}
                                    start={filterData.size}
                                    step={10}
                                    connect
                                    onSlide={onSlideSize}
                                    direction={AuthData.lang !== "ar" ? "ltr" : "rtl"}

                                  />
                                </DropdownMenu>
                              </Dropdown>
                            </div> */}
													</div>
												</Col>
												<Col
													lg={filterData.activeTab === "2" ? 4 : 4}
													className="">
													<div className="d-md-flex h-100 gap-2 d-block">
														{filterData.activeTab === "1" && (
															<div className="w-100 custom-search2">
																<Select
																	placeholder={t("property")}
																	// options={  [{ label: t("select label"), value: "Select" }, ...filterData.unitTypeOptions]}
																	options={unitTypeOptions}
																	onChange={(data) => {
																		dispatch(
																			appendFilters({ unitType: [data] })
																		);
																	}}
																	value={
																		filterData?.unitType?.length
																			? filterData?.unitType[0]
																			: null
																	}
																/>
															</div>
														)}
														{/* <div className='w-100 ps-2 pe-2'>
                            <Select
                                placeholder={t("Finishing type")}
                                options={[...finishingOptions]}
                                className='mb-3'
                                onChange= {data => {
                                  dispatch(appendFilters({ finishingType: [data] }))
                                }}
                                value={filterData ?.finishingType?.length > 0 ?filterData ?.finishingType[0] : null}
                              />
                            </div> */}
														{filterData.activeTab === "2" && (
															<div className="w-100 custom-search2">
																<Select
																	placeholder={t("Payment")}
																	options={
																		filterData.activeTab === "1"
																			? [
																					{
																						label: t("select label"),
																						value: "Select",
																					},
																					...payment_methods,
																			  ]
																			: [
																					{
																						label: t("select label"),
																						value: "Select",
																					},
																					...resalePayment_methods,
																			  ]
																	}
																	onChange={(data) => {
																		if (data.value === "Select") {
																			dispatch(
																				appendFilters({
																					paymentMethods: [],
																				})
																			);
																		} else {
																			dispatch(
																				appendFilters({
																					paymentMethods: [data.value],
																				})
																			);
																		}
																	}}
																	value={
																		filterData.paymentMethods.length
																			? {
																					label: t(
																						`${filterData?.paymentMethods[0]}`
																					),
																					value: filterData?.paymentMethods[0],
																			  }
																			: null
																	}
																/>
															</div>
														)}
														<div className="w-100">
															{filterData.activeTab === "1" ? (
																<div className="custom-search2">
																	<Select
																		placeholder={t("Price")}
																		className="border-0"
																		options={countriesOptions}
																		onChange={(data) =>
																			dispatch(appendFilters({ country: data }))
																		}
																		value={filterData.country}
																	/>
																</div>
															) : (
																<div className="custom-search2">
																	<Select
																		placeholder={t("Price")}
																		options={countriesOptions}
																		className="border-0"
																		onChange={(data) =>
																			dispatch(appendFilters({ country: data }))
																		}
																		value={filterData.country}
																	/>
																</div>
															)}
														</div>
													</div>
												</Col>
												<Col
													lg={1}
													md={3}
													className="p-lg-0 pb-4 pb-lg-0 d-flex align-items-center">
													<button
														className="btn font-size-16 text-center text-white"
														type="button"
														style={{
															height: "40px",
															width: "40px",
															borderRadius: "50%",
															padding: "8px",
															background: "var(--primary-color)",
														}}
														onClick={() => {
															handleSubmit();
														}}>
														<i className="fa fa-search" />
													</button>
												</Col>
											</Row>
										</div>
									</div>
								</AvForm>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResaleHeader;
